import { MutationTree } from 'vuex'
import { FeatureFlagsState } from '@/@types'

const mutations: MutationTree<FeatureFlagsState> = {
  FEATURE_FLAGS_UPDATED: (state, newFlags) => {
    state.blackFridayEnabled = newFlags.blackFridayEnabled
    state.cyberMondayEnabled = newFlags.cyberMondayEnabled
    state.tcsPromoEnabled = newFlags.tcsPromoEnabled
    state.flashSaleEnabled = newFlags.flashSaleEnabled
    state.showB2BBanner = newFlags.showB2BBanner
    state.springPromoEnabled = newFlags.springPromoEnabled
    state.premiumPlusEnabled = newFlags.premiumPlusEnabled
    state.maySaleEnabled = newFlags.maySaleEnabled
    state.mayFlashSaleEnabled = newFlags.mayFlashSaleEnabled
    state.summerSavingsEnabled = newFlags.summerSavingsEnabled
    state.julySaleEnabled = newFlags.julySaleEnabled
    state.showDefaultSmallPrint = newFlags.showDefaultSmallPrint
    state.hubspotIntegration = newFlags.hubspotIntegration
    state.restrictStandAloneCertsEnabled = newFlags.restrictStandAloneCertsEnabled
    state.maintenanceScheduled = newFlags.maintenanceScheduled
    state.maintenanceOnGoing = newFlags.maintenanceOnGoing
  },
}

export default mutations
